import { RequestService } from '../../../../../common/services/RequestService';
import { GET_ALL_ORDERS } from '../constants';
import { dataAdjustmentResponse } from '../orders/dataAdjustment';

export const getAllOrdersRequest = async (profileId, sort) => {
  const query = '?' + (new URLSearchParams(sort).toString())

  const response = await RequestService.get(
    GET_ALL_ORDERS.replace('{profile_id}', profileId) + query
  );

  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(order => dataAdjustmentResponse(order))
  );
};
